import CommonLocale from '../module/it.common.locale';
import Dashboard from '../module/it.dashboard.locale';
import DashboardImageSummary from '../module/it.dashboard_image_summary.locale';
import DashboardImageTransaction from '../module/it.dashboard_image_transactions.locale';
import GenerateContentModal from '../module/it.generate_content_modal.locale';
import GenerateImageVariationsModal from '../module/it.generate_image_variation_modal.locale';
import ImageFormRules from '../module/it.image_form_rule.locale';
import ModalQuickActionVariations from '../module/it.modal_quick_action_variations.locale';
import ShowImageVariationsModal from '../module/it.show_image_variations_modal.locale';
import ShowVariationsModal from '../module/it.show_variations_modal.locale';
export default {
    it: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, CommonLocale), Dashboard), GenerateContentModal), ShowVariationsModal), DashboardImageSummary), DashboardImageTransaction), GenerateImageVariationsModal), ShowImageVariationsModal), ImageFormRules), ModalQuickActionVariations),
};
